import { render, staticRenderFns } from "./ValidationVoter.vue?vue&type=template&id=429f8624&"
import script from "./ValidationVoter.vue?vue&type=script&lang=js&"
export * from "./ValidationVoter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports